// ShimmerKanban.jsx
import React from 'react';

const ShimmerKanban = () => {
  const shimmerColumns = Array(10).fill(null); // Match number of columns in KanbanBoard

  return (
    <div className="w-full overflow-x-auto pb-4 custom-scrollbar pipeline">
      <div className="flex mx-10 mt-4 gap-5">
        {shimmerColumns.map((_, index) => (
          <div key={index} style={{ minWidth: '380px' }}>
            <div className="flex flex-col gap-2">
              <div className="h-6 w-3/4 bg-gray-300 animate-pulse rounded-xl" />
              <div className="flex gap-2">
                <div className="h-6 w-1/2 bg-gray-300 animate-pulse rounded-xl" />
                <div className="h-6 w-1/4 bg-gray-300 animate-pulse rounded-xl" />
              </div>
            </div>
            <div className="w-full mt-4">
              <div className="bg-gray-200 h-[calc(100vh-270px)] rounded-lg p-4">
                {Array(3).fill(null).map((_, cardIndex) => (
                  <div
                    key={cardIndex}
                    className="h-32 w-full bg-gray-300 animate-pulse rounded-lg mb-4"
                  />
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShimmerKanban;